<div class="modal-container">
  <!-- Header -->
  <ion-toolbar class="safe-area-top-pad">
    <div class="modal-header">
      <h2 class="modal-title">{{ title || 'Terms and Conditions' }}</h2>
      <ion-button fill="clear" class="close-button" (click)="dismiss()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </div>
  </ion-toolbar>

  <!-- Content -->
  <div class="modal-body">
    <ion-content class="terms-content">
      <div class="content-wrapper">
        <div class="section" *ngIf="hasDynamicContent; else defaultContent">
          <p class="section-text" [innerHTML]="message"></p>
        </div>

        <ng-template #defaultContent>
        <!-- Welcome Section -->
        <div class="section">
          <h3 class="section-title">Welcome to Travel VIP!</h3>
          <p class="section-text">
            By accessing or using our website, mobile app, or related services,
            you agree to comply with the following Terms & Conditions. Please
            read them carefully.
          </p>
        </div>

        <!-- 1. Acceptance of Terms -->
        <div class="section">
          <h4 class="subsection-title">1. Acceptance of Terms</h4>
          <p class="section-text">
            By using Travel VIP, you agree to these Terms. If you do not agree,
            you may not use our services.
          </p>
        </div>

        <!-- 2. Eligibility -->
        <div class="section">
          <h4 class="subsection-title">2. Eligibility</h4>
          <p class="section-text">
            You must be at least 18 years old (or the age of legal majority in
            your country) to use our services. By using Travel VIP, you confirm
            that you meet the eligibility requirements.
          </p>
        </div>

        <!-- 3. User Accounts -->
        <div class="section">
          <h4 class="subsection-title">3. User Accounts</h4>
          <ul class="bullet-list">
            <li>
              You are responsible for maintaining the confidentiality of your
              account and password.
            </li>
            <li>
              You agree to provide accurate, current, and complete information
              when registering.
            </li>
            <li>
              You are responsible for all activities that occur under your
              account.
            </li>
          </ul>
        </div>

        <!-- 4. Use of Services -->
        <div class="section">
          <h4 class="subsection-title">4. Use of Services</h4>
          <ul class="bullet-list">
            <li>
              Travel VIP provides travel booking and related services, including
              flights, hotels, and other offerings.
            </li>
          </ul>
        </div>

        <!-- Additional sections can be added here -->
        <div class="section">
          <h4 class="subsection-title">5. Bookings, Payments & Cancellations</h4>
          <ul class="bullet-list">
            <li>Prices displayed are subject to availability and changes.
            </li>
            <li>Bookings may be governed by additional terms of airlines, hotels, or service providers.</li>
            <li>Cancellation, refund, and modification policies depend on the respective provider’s rules and Travel VIP’s policies.</li>
          </ul>
        </div>

        <div class="section">
          <h4 class="subsection-title">6. Intellectual Property</h4>
          <p class="section-text">
            All content, trademarks, designs, and materials on Travel VIP remain our property or that of our partners and licensors.
          </p>
        </div>

        <div class="section">
          <h4 class="subsection-title">7. Limitation of Liability</h4>
          <p class="section-text">
            Travel VIP acts as a platform connecting users with travel service providers. We are not liable for delays, cancellations, or issues caused by third-party providers.
          </p>
        </div>

        <div class="section">
          <h4 class="subsection-title">8. Termination</h4>
          <p class="section-text">
            We reserve the right to suspend or terminate your account if you violate our Terms or misuse the platform.
          </p>
        </div>

        <div class="section">
          <h4 class="subsection-title">9. Changes to terms</h4>
          <p class="section-text">
            We may update these Terms at any time. Continued use of Travel VIP means you accept the updated Terms.
          </p>
        </div>
      </ng-template>
      </div>
    </ion-content>
  </div>

  <!-- Footer Button -->
  <div class="modal-footer">
    <ion-button expand="block" class="primary-btn" (click)="dismiss()">
      {{ btnText || 'Close' }}
    </ion-button>
  </div>
</div>
